import React, { useEffect, useState, useCallback } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import transportationEoLIcon from "../../../../../assets/new-product-detail-cats/header-icons/prod-deliveries-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getTransportationEoL43Totals } from "../../../../../apis/Product/TransportationEoLFlow43Api";

const TransportationEoL43Icon = () => (
  <img src={transportationEoLIcon} alt="Transportation EoL Icon" width={76} height={76} />
);

const TransportationEoL43Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  refreshTrigger,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalTransportationEoLItem, setTotalTransportationEoLItem] = useState(null);

  const fetchTotals = useCallback(() => {
    if (productId) {
      getTransportationEoL43Totals({
        productId,
        setTotals: setTotalTransportationEoLItem,
      });
    }
  }, [productId]);

  useEffect(() => {
    fetchTotals();
  }, [fetchTotals, refreshTrigger]);

  // Listen for refresh events from table components
  useEffect(() => {
    const handleRefresh = () => {
      fetchTotals();
    };
    
    window.addEventListener('refresh-transportation-eol-43-totals', handleRefresh);
    
    return () => {
      window.removeEventListener('refresh-transportation-eol-43-totals', handleRefresh);
    };
  }, [fetchTotals]);

  return (
    <CategoryComponent
      show={show}
      className={`transportation-eol-43-category ${className || ""}`}
      leftBoxProps={{
        icon: <TransportationEoL43Icon />,
        title: t("TRANSPORTATION_EOL_FU") || "Transportation in regards to EoL for the FU",
        description:
          t("TRANSPORTATION_EOL_FU_DESC") ||
          "Includes the transport of the removed product to the waste processing or disposal facility. It models the distance travelled, vehicle type, fuel use, and related emissions.",
        productId: productId,
        isSystemBoundary: true,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_43") || "Total for Flow 43",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalTransportationEoLItem?.impact_totals || null,
        lastUpdated: totalTransportationEoLItem?.updated_at
          ? formatDate(totalTransportationEoLItem?.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default TransportationEoL43Header;

